const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "Social Buy Club", // <title>
  shortSiteTitle: "for your day to day life", // <title> ending for posts and pages
  siteDescription: "No need to fuss around when we are here to tailor products to your need.",
  siteUrl: "https://socialbuyclub.com",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "PurpleQuantum, Inc",
  authorTwitterAccount: "greglobinski",
  // info
  infoTitle: "social buy club",
  infoTitleNote: "for your day to day life",
  // manifest.json
  manifestName: "Social Buy Club",
  manifestShortName: "Social Buy Club", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "support@purplequantum.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/greglobinski" },
    { name: "twitter", url: "https://twitter.com/greglobinski" },
    { name: "facebook", url: "http://facebook.com/greglobinski" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js